import classnames from "classnames";
import { ReactComponent as TickMarkImage } from "../../../assets/tick-mark.svg";
import {
  faArrowUp,
  faArrowUpRightFromSquare,
  faDesktop,
  faMobile,
  faRocket,
  faTablet,
  faXmark,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useEffect } from "react";
import { useContext } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useState } from "react";
import { GrigoraEditorContext } from "../context";
import LoaderSmall from "../../loader/loadersmall";
import "./index.scss";
import {
  EditPopover,
  Popover,
  PopoverAnchor,
  PopoverContent,
  TextInput,
  Tooltip,
} from "../../input";
import { ReactComponent as Logo } from "../../../assets/grigoraWhite.svg";
import { GrigoraDashboardContext } from "../../dashboard/context";
import { useEditor } from "@craftjs/core";
import { motion } from "framer-motion";
import { isJsonString } from "../../helpers";
import Debug from "./debug";
import UndoRedo from "./undo-redo";
import { Mobile, Tablet } from "../../../assets/ui-icons";
import HomeMenu from "./home";
import Devices from "./devices";
import classNames from "classnames";
import DateDisplay from "../../ui-kit/date-display";
import { ModalInput } from "../../ui-kit";
import ConfettiExplosion from "react-confetti-explosion";
import { INPUT_LIMITS } from "../../input-limits";
import { APIProviderContext } from "../../api";
import Billing from "../../../pages/settings/billing";

const GrigoraEditorHead = ({ setRunEditorTutorial }) => {
  const {
    project,
    publishProject,
    isPublishing,
    leftWidget,
    setLeftWidget,
    updatePages,
    pagesData,
    currentPage,
    displaySize,
    setDisplaySize,
    routerState,
    projectComponents,
    isPublishMenuOpen,
    setIsPublishMenuOpen,
    isNewProjectPublished,
    setIsNewProjectPublished,
    setProjectData,
  } = useContext(GrigoraEditorContext);

  const { projectID, domain, isSubscribed, isFreeTrialActive } = useContext(
    GrigoraDashboardContext,
  );
  const [importJson, setimportJson] = useState("");
  const [showPricingPlans, setShowPricingPlans] = useState(false);

  const {
    query,
    actions: { deserialize },
  } = useEditor((state) => ({}));

  return (
    <motion.div
      initial={{ height: 0, opacity: 0 }}
      animate={{ height: 40, opacity: 1 }}
      exit={{ height: 0, opacity: 0 }}
      transition={{ duration: 0.1 }}
      className="flex select-none bg-white overflow-hidden border-b border-[1px] relative z-[1000]"
    >
      <div className="flex flex-1 items-center justify-center ">
        <div className="flex flex-1 items-center">
          <HomeMenu setRunEditorTutorial={setRunEditorTutorial} />
          <Debug />
        </div>
      </div>
      <div className="flex flex-1 items-center w-full justify-center">
        <input
          type="text"
          minLength={INPUT_LIMITS["website-name"].minlength}
          maxLength={INPUT_LIMITS["website-name"].maxlength}
          size={project?.name?.length}
          id="project-name"
          placeholder="Website Name"
          className="px-2 py-[2px] text-center outline-none text-sm max-w-[600px] truncate border-b border-transparent hover:border-b-ui-blue min-w-[300px]"
          onChange={(e) => {
            if (e.target.value.length > 63) {
              return;
            }
            setProjectData({
              ...project,
              name: e.target.value,
            });
          }}
          value={project.name}
        />
      </div>
      <div className="flex flex-1 justify-end items-center">
        <UndoRedo />
        <Devices />
        <div
          id="publish"
          className="flex justify-center items-center text-white"
        >
          {routerState?.isFirstTime ? (
            <>
              <button
                onClick={() => {
                  if (isSubscribed) {
                    publishProject(query);
                  }
                  setShowPricingPlans(true);
                }}
                disabled={isPublishing}
                className={classNames(
                  `grigora-editor__publish-btn h-10 px-3 flex justify-center items-center text-sm text-ui-blue hover:bg-gray-200 cursor-pointer`,
                  {
                    "!text-gray-500": isPublishing,
                  },
                )}
              >
                <span className="mr-1 ">
                  <FontAwesomeIcon icon={faRocket} size="sm" />
                </span>
                <span className="font-semibold text-grigora-base select-none">
                  Finish
                </span>
              </button>

              <ModalInput
                isOpened={isNewProjectPublished}
                onOutsideClick={() => {
                  setIsNewProjectPublished(false);
                }}
              >
                <div className="rounded-[21px] bg-white grigora-add-new-page gap-5 grigora-custom-scrollbar-dark flex flex-col w-[600px] mw-[70vh] p-8 cursor-default">
                  <div className="flex flex-col gap-2 items-center">
                    <img
                      src="/images/congratulations.png"
                      alt="Congratulations"
                      className="w-full aspect-[2360/1777]"
                    />
                    {/* <TickMarkImage width={200} height={200} /> */}
                    {/* <h1 className="modal-heading mt-4">Congratulations! 🤩</h1> */}
                    <h4 className="text-grigora-base mt-[-50px]">
                      Your website has been published.
                    </h4>
                  </div>
                  <div className="flex">
                    <Link
                      to={`https://${domain}`}
                      target="_blank"
                      className="mx-auto w-8/12"
                    >
                      <Tooltip
                        text={"Visit Your Website"}
                        placement="right"
                        mouseEnterDelay={1}
                      >
                        <div className="new-site-modal-link text-grigora-base w-full text-center rounded-[21px] flex gap-2 justify-center p-2 px-3 items-center shadow-main duration-300">
                          <span className="truncate">{domain}</span>
                          <FontAwesomeIcon
                            icon={faArrowUp}
                            className="arrow text-grigora-base ml-1"
                          />
                        </div>
                      </Tooltip>
                    </Link>
                  </div>
                  <div className="w-full text-center rounded-[21px] flex flex-col px-3 items-center">
                    <Link
                      to={`/site/${projectID}/`}
                      className="w-44 text-center grigora-action-btn"
                    >
                      Go to Dashboard
                    </Link>
                    <div className="flex w-full justify-center">
                      <ConfettiExplosion
                        particleCount={400}
                        duration={4000}
                        width={2000}
                        height={1700}
                        force={0.8}
                        zIndex={9999999999}
                      />
                    </div>
                  </div>
                  {!isSubscribed && (
                    <div className="text-center">
                      Your 15 days free trial has been started!
                    </div>
                  )}{" "}
                </div>
              </ModalInput>
            </>
          ) : (
            <>
              <Popover
                placement="bottom"
                open={isPublishMenuOpen}
                onOpenChange={setIsPublishMenuOpen}
              >
                <PopoverAnchor>
                  <div
                    onClick={() => setIsPublishMenuOpen((v) => !v)}
                    className={`grigora-editor__publish-btn h-10 px-3 flex justify-center items-center text-sm text-black hover:bg-gray-200 cursor-pointer ${
                      isPublishMenuOpen ? "active" : ""
                    }`}
                  >
                    <span className="mr-1 text-ui-blue">
                      <FontAwesomeIcon icon={faRocket} size="md" />
                    </span>
                    <span className="font-semibold text-grigora-base select-none text-ui-blue">
                      Publish
                    </span>
                  </div>
                </PopoverAnchor>
                <PopoverContent className="!z-[1000] !shadow-editor-floating-elements">
                  <div className="z-[10000] cursor-default text-grigora-base p-5 w-[300px] text-center ">
                    {isPublishing ? (
                      <>
                        <div className="grigora-editor__publish-pending backdrop-blur-sm absolute inset-0 flex items-center justify-center ">
                          <LoaderSmall />
                        </div>
                      </>
                    ) : null}
                    <div className="grigora-editor__publish-status mb-4 flex justify-between">
                      <div className="flex">Status</div>
                      {project.status === "published" ? (
                        <div className="flex items-center gap-[5px]">
                          <span className="w-3 h-3 rounded-full bg-green-500 "></span>
                          Published
                        </div>
                      ) : (
                        <div className="flex items-center gap-[5px]">
                          <span className="w-3 h-3 rounded-full bg-red-500 "></span>
                          Not Published
                        </div>
                      )}
                    </div>
                    {project.last_update ? (
                      <div className="grigora-editor__publish-update-date mb-4 gap-[10px] flex items-center justify-between">
                        <div className="flex whitespace-nowrap">
                          Last Updated
                        </div>
                        <div className="max-w-[180px] items-center gap-[5px] text-ellipsis whitespace-nowrap overflow-hidden">
                          <span>
                            <DateDisplay
                              date={
                                new Date(Number(project.last_update) * 1000)
                              }
                            />
                          </span>
                        </div>
                      </div>
                    ) : null}
                    {project.last_published ? (
                      <div className="grigora-editor__publish-date mb-4 gap-[10px] flex items-center justify-between">
                        <div className="flex whitespace-nowrap">
                          Last Published
                        </div>
                        <div className="max-w-[180px] items-center gap-[5px] text-ellipsis whitespace-nowrap overflow-hidden">
                          <span>
                            <DateDisplay
                              date={
                                new Date(Number(project.last_published) * 1000)
                              }
                            />
                          </span>
                        </div>
                      </div>
                    ) : null}
                    <div className="grigora-editor__publish-link mb-4 gap-[10px] flex items-center justify-between">
                      <div className="flex whitespace-nowrap">URL</div>
                      <div className="flex gap-[10px] items-center">
                        <div className="max-w-[180px] items-center gap-[5px] text-ellipsis whitespace-nowrap overflow-hidden text-ui-blue">
                          <a
                            href={`https://${domain}`}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {domain}
                          </a>
                        </div>
                        <a
                          className="flex whitespace-nowrap cursor-pointer text-ui-blue"
                          href={`https://${domain}`}
                          target="_blank"
                          rel="noreferrer"
                        >
                          <FontAwesomeIcon
                            icon={faArrowUpRightFromSquare}
                            size="sm"
                          />
                        </a>
                      </div>
                    </div>
                    <div
                      onClick={() => {
                        updatePages(query);
                      }}
                      className={`border-[1px] hover:bg-gray-100 cursor-pointer select-none mb-4 py-1 px-5 rounded text-sm`}
                    >
                      Save
                    </div>
                    <div
                      onClick={() => {
                        if (isSubscribed || isFreeTrialActive) {
                          publishProject(query);
                          return;
                        }
                        // Save the changes and show the pricing plans
                        updatePages(query);
                        setShowPricingPlans(true);
                      }}
                      className={`border-[1px] hover:bg-gray-100 cursor-pointer select-none py-1 px-5 rounded text-sm`}
                    >
                      Save & Publish
                    </div>
                  </div>
                </PopoverContent>
              </Popover>
            </>
          )}
        </div>
      </div>
      {!isSubscribed && (
        <ModalInput
          isOpened={showPricingPlans}
          onOutsideClick={() => {
            setShowPricingPlans(false);
          }}
        >
          <div className="rounded-[0px] bg-white p-6 px-10 w-[100vw] h-[100vh] relative">
            <button
              onClick={() => {
                setShowPricingPlans(false);
              }}
              className="absolute top-2 right-2 p-4 rounded-lg duration-300 hover:bg-gray-50"
            >
              <FontAwesomeIcon icon={faXmark} className="text-[20px]" />
            </button>
            <div className="w-full pt-5"></div>
            <Billing
              small={true}
              buttonText="Buy Now"
              showPricingPlans={false}
            />
          </div>
        </ModalInput>
      )}
    </motion.div>
  );
};

export default GrigoraEditorHead;
